import React from "react";
import Aviator from "./Aviator";
import bgimage from "./assets/img/bg-rotate-old.svg";

export default function Rightside() {
  return (
    <div>
      <div id="Rightside">
        <div className="Rightsidebar position-relative">
          <Aviator />
          <img src={bgimage} class="bg-line" />
        </div>
      </div>
    </div>
  );
}
